<template>
    <ModalFormCard class="modal-default" :action='action'>
        <template #title>New prospect</template>

        <template #default="{ saving, errors }">
            <Input name="company_name" label='Company name' v-model:value='value.company_name' />
            <Input name="phone_number" label='Phone number' v-model:value='value.phone_number' class='mt-4' />
            <Input name="email" label='Email' v-model:value='value.email' class='mt-4' />

            <Select :options='user.industries.map((i) => {return { value: i.id, html: i.name }})' 
                v-model:value='value.industry_id' label='Trade' class='mt-4' name='industry_id' 
                @update:value='getLocations'
            />

            <Select :options='locations' valueKey='id' v-model:value='value.location_area_id'
                label='Area' class='mt-4' :disabledOptionsEnabled='false' name='location_area_id'
            >
                <template #option="{ option }">
                    <div class='flex items-center gap-2 w-full'>
                        <IconTickCircle v-if='option.disabled == 0' class='stroke-green-600 w-4 h-4 shrink-0' />
                        <IconStatusFalse v-else class='stroke-red-700 w-4 h-4 shrink-0' />
                        <p>{{ option.name }}</p>
                    </div>
                </template>
            </Select>

            <div class="modal-buttons pt-6">
				<ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
                    Create prospect
				</ButtonSaving>
            </div>

        </template>

    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'

    export default {
        mixins: [Modal],

        data() {
            return {
                action: '/admin/sales/prospects',
                locations: [],
                value: {
                    location_area_id: null,
                    industry_id: 1,
                    company_name: '',
                    email: '',
                    phone_number: ''
                }
            }
        },

        created() {
            this.getLocations();
        },

        methods: {
            getLocations() {
                this.$axios.post('/admin/actions/location-areas-for-prospect', {
                    industry_id: this.value.industry_id
                })
                    .then(res => {
                        this.locations = res;
                    })
            }
        },

        computed: {
            user() {
                return this.$authSanctum.getUser()
            }
        }
    }
</script>